import { filter } from 'rxjs/operators'
import { Component, Input } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { MenusComponentModel } from '../menus/menus.component'

export interface HeaderComponentModel {
  menu: MenusComponentModel
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  ccLogoSrc = 'assets/images/cc-logo.png'
  ccEchangeLogoSrc = 'assets/images/cc-exchange-logo.png'
  logoSrc = this.ccLogoSrc
  @Input() model: HeaderComponentModel

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        if (urlAfterRedirects && typeof urlAfterRedirects === 'string') {
          this.logoSrc = this.showCCLogo(urlAfterRedirects) ? this.ccLogoSrc : this.ccEchangeLogoSrc
        }
      })
  }

  private showCCLogo(url) {
    return url.includes('/home') && !url.includes('/home/index')
  }
}
